import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Plans,
  Kinship,
  Offices,
  Sellers,
  GetFiles,
  Services,
  Proposal,
  DeleteFiles,
  ChangeStatus,
  CancelProposal,
  CategoryPlans,
  Organizations,
  CreateProposal,
  UpdateProposal,
  DeleteProposal,
  GetProposalById,
  ReactiveProposal,
  ProposalGetAssociates,
  GetProposalsSituation,
} from '../../../store/actions';

/**
 * ProposalsInjection is responsible for injecting the methods about store.
 *
 * @return
 *  get: () => Void
 *
 */
export const ProposalsInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   *
   * Proposals
   */

  const proposal = () => {
    dispatch(Proposal());
  };

  const getProposalById = (id) => {
    dispatch(GetProposalById(id));
  };

  const getProposalsBySituation = async (office, situation, params) => {
    dispatch(GetProposalsSituation(office, situation, params));
  };

  const getProposalsByAssociate = useCallback(
    (id) => {
      dispatch(ProposalGetAssociates(id));
    },
    [dispatch]
  );

  const createProposal = async (data, history) => {
    dispatch(CreateProposal(data, history));
  };

  const updateProposal = async (id, data, history) => {
    dispatch(UpdateProposal(id, data, history));
  };

  const deleteProposal = async (id) => {
    dispatch(DeleteProposal(id));
  };

  const cancelProposal = (data) => {
    dispatch(CancelProposal(data));
  };

  const changeStatus = (data) => {
    dispatch(ChangeStatus(data));
  };

  const reactiveProposal = (data) => {
    dispatch(ReactiveProposal(data));
  };

  /**
   * @return Void
   *
   * More modules:
   */
  const getFiles = useCallback(
    (id) => {
      dispatch(GetFiles(id));
    },
    [dispatch]
  );

  const deleteFiles = (id) => {
    dispatch(DeleteFiles(id));
  };

  const getCategoryPlans = async () => {
    dispatch(CategoryPlans());
  };

  const getPlans = async () => {
    dispatch(Plans());
  };

  const getSellers = async () => {
    dispatch(Sellers());
  };

  const getOrganizations = async () => {
    dispatch(Organizations());
  };

  const getKinship = async () => {
    dispatch(Kinship());
  };

  const getServices = async () => {
    dispatch(Services());
  };

  const getOffices = async () => {
    dispatch(Offices());
  };

  /**
   * @return Void  
  /**
   * 
   *
   *
   */

  const {
    // Proposals Redux
    success,
    proposalsAssociates,
    proposalsBySituation,
    successSituation,
    loadingBySituation,
    loadingByAssociates,
    // Others modules redux
    files,
    plans,
    sellers,
    kinships,
    services,
    propostas,
    successFiles,
    categoryPlans,
    organizations,
    offices,
  } = useSelector((state) => ({
    plans: state.Plans.plans,
    files: state.Files.files,
    sellers: state.Sellers.sellers,
    success: state.Proposal.success,
    kinships: state.Kinship.kinships,
    services: state.Services.services,
    successFiles: state.Files.success,
    propostas: state.Proposal.proposalId,
    categoryPlans: state.CategoryPlans.categoryPlans,
    organizations: state.Organizations.organizations,
    successSituation: state.Overview.successSituation,
    proposalsAssociates: state.Proposal.proposalsAssociates,
    proposalsBySituation: state.Overview.proposalsBySituation,
    loadingByAssociates: state.Proposal.loadingByAssociates,
    loadingBySituation: state.Overview.loadingBySituation,
    offices: state.Offices.offices,
  }));

  return {
    files,
    plans,
    sellers,
    success,
    offices,
    proposal,
    getFiles,
    getPlans,
    kinships,
    services,
    propostas,
    getSellers,
    getKinship,
    getOffices,
    getServices,
    deleteFiles,
    changeStatus,
    successFiles,
    categoryPlans,
    organizations,
    deleteProposal,
    createProposal,
    updateProposal,
    cancelProposal,
    getProposalById,
    getOrganizations,
    reactiveProposal,
    successSituation,
    getCategoryPlans,
    loadingByAssociates,
    proposalsAssociates,
    proposalsBySituation,
    getProposalsBySituation,
    getProposalsByAssociate,
    loadingBySituation,
  };
};
